import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TableDialogModel } from '@pg-app/partner/dashboard/model/table-dialog.model';
import { TableDialogService } from '@pg-app/partner/dashboard/services/table-dialog.service';

@Component({
  selector: 'np-area-chart',
  templateUrl: './area-chart.component.html',
  styleUrls: ['./area-chart.component.scss']
})
export class AreaChartComponent implements OnChanges, OnInit {
  @Input()
  data: any;
  single = [
    {
      name: '',
      value: 0
    }
  ];
  multi = [];
  view: any[] = [700, 250];
  showYAxis = true;
  showXAxis = true;
  showGridLines = true;
  gradient = false;
  showLegend = true;

  colorScheme = {
    domain: ['#00B600']
  };
  colorSchemeLine = {
    domain: ['#00B600']
  };
  colorSchemeCircle = {
    domain: ['#3c455c']
  };
  public innerWidth: any;

  constructor(private tableDialogService: TableDialogService) {
  }

  onResize(event) {
    // if(this.innerWidth !== window.innerWidth) {
    //   location.reload();
    // }
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges() {
    if (this.data && this.data.length > 0) {
      this.single = [
        {
          name: '',
          value: this.data[0].value
        }
      ];
      this.multi = [
        {
          name: '',
          series: []
        }
      ];
      this.multi[0].series.push({
        name: 'START',
        value: this.data[0].value,
        hideFirstLast: true
      });

      for (let i = 0; i < this.data.length; i++) {
        this.multi[0].series.push({
          name: this.data[i].month,
          value: this.data[i].value
        });
      }

      this.multi[0].series.push({
        name: 'END',
        value: this.data[this.data.length - 1].value,
        hideFirstLast: true
      });
    }
  }

  public showDialog(data) {
    const year = new Date().getFullYear();
    this.tableDialogService.showDialog(
      new TableDialogModel('Monthly Commission', {
        year: this.data.find(item => item.month === data.name).year,
        month: data.name
      })
    );
  }
}
